import React from 'react';

import { Button, Flex, Form } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { useNotification } from 'segments/hooks';

import { InputStr, SubmiteButton } from 'shared/FormItems';

import { SelectBookingTime } from 'features/bookingTimeSelector';
import { BookingWaitInfo, useDeleteBookingWaitMutation, useUpdateBookingWaitMutation } from 'features/bookingWait';
import { SelectUsers } from 'features/users';

type FormData = {
  endTime: Dayjs;
  startTime: Dayjs;
  note?: string;
  userId?: number;
}
interface Props {
  initDate: BookingWaitInfo;
}

function EditBookingWaitForm({ initDate }: Props) {
  const { t } = useTranslation();

  const [form] = Form.useForm<FormData>();
  const [updateBookingWait, { isError, isLoading, isSuccess, error }] = useUpdateBookingWaitMutation();
  const [deleteBookingWait, { isError: isDelteError, isLoading: isDeleteLoading, isSuccess: isDeleteSuccess, error: deleteError }] = useDeleteBookingWaitMutation();

  useNotification({
    isSuccess,
    isError,
    error
  });

  useNotification({
    isSuccess: isDeleteSuccess,
    isError: isDelteError,
    error: deleteError
  });

  const handleDelte = () => {
    deleteBookingWait(initDate.id);
  };

  const onFinish = ({ endTime, startTime, ...values }: FormData) => {
    updateBookingWait({
      id: initDate.id,
      endTime: endTime.format('YYYY-MM-DDTHH:mm:ss'),
      startTime: startTime.format('YYYY-MM-DDTHH:mm:ss'),
      ...values
    });
  };

  return (
    <Form
      name="basic"
      layout="vertical"
      form={form}
      initialValues={{
        ...initDate,
        startTime: dayjs(initDate.startTime),
        endTime: dayjs(initDate.endTime),
      }}
      onFinish={onFinish}
      autoComplete="off"
      className="edit-user__form"
    >
      <SelectBookingTime form={form} showStartTime />
      <InputStr type='note' />
      <SelectUsers oneSelectMode />
      <Flex justify='space-between' style={{ marginTop: '18px' }}>
        <Button style={{ width: '48%' }} disabled={isLoading || isDeleteLoading}>
          {t('booking-wait.button.booking')}
        </Button>
        <Button danger style={{ width: '48%' }} onClick={handleDelte} disabled={isLoading || isDeleteLoading}>
          {t('booking-wait.button.delete')}
        </Button>
      </Flex>
      <SubmiteButton submiteText={t('table.edit')} isLoading={isLoading || isDeleteLoading} />
    </Form >
  );
}

export default EditBookingWaitForm;
